import { defineMessage } from 'services/localization';

export const messages = {
    doneButtonText: defineMessage('confirm'),
    message: defineMessage('please_confirm_your_sel_onnected_to_approvalmax'),
    warningText: defineMessage('if_you_change_the_selec_other_xero_organisation'),
    yourXeroOrg: defineMessage('select_xero_organisation'),
    popupTitle: defineMessage('select_xero_organisation_1'),
};
